import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ProductVariationsNode } from "@common/build/types";

const VariantOptions = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as ProductVariationsNode;

    const toggleCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["showPrices"], value: checked }));
    };

    return (
        <SidebarCollapse title="Variant Options" parent={parent}>
            <Toggle label="Show price" checked={!!node?.showPrices} callback={toggleCallback} />
        </SidebarCollapse>
    );
};

export default VariantOptions;
